<div class="btn-group {{theme$ | async}}">
  <lib-button
    id="tclass-filter-button"
    [color]="'secondary'"
    [size]="'custom'"
    [fontSize]="14"
    [width]="50"
    [height]="24"
    [matTooltip]="'LOGBOOK.TURBINE.FILTER.FILTER' |translate" type="button"
    [faIcon]="'far fa-regular fa-filter'"
    (buttonClicked)="toggleDropdown()" >
  </lib-button>

  @if (toggle) {
    <ul (mouseleave)="closeDropdown()" class="dropdown-menu mt-2 pt-3 pl-1 pr-1" role="menu"
      [ngClass]="{'dropdown-menu-right' : offsetRight, 'dropdown-menu-right-no-offset' : !offsetRight}"
      [ngStyle]="{'width': view === 'general' || view === 'daily' ? '50rem' : view === 'losses_review' ? '40rem' : '25rem'}">
      <div class="row justify-content-between">
        <div class="filter-title">
          <i class="far fa-filter filter-icon filter-icon-big" aria-hidden="true"></i>
          <span class="text-primary" style="font-size: 16px; font-weight: bold">{{"LOGBOOK.TURBINE.FILTER.FILTER" |translate}}</span>
        </div>
        <span (click)="defaultValues()" class="pull-right pr-2" style="color: #85a2b6; font-size: 13px; cursor: pointer">
          {{"LOGBOOK.TURBINE.FILTER.SET_TO_DEFAULT" |translate}}
        </span>
      </div>
      <hr style="margin: 10px">
      @if (view === 'general' || view === 'daily') {
        <div class="row">
          <div class="col-2 pl-2 vertical-spacer">
            <p class="pl-4 text-primary font-size-small"><b>{{"LOGBOOK.TURBINE.FILTER.DURATION" |translate}}</b></p>
            <ng-container *ngTemplateOutlet="durationFilter"></ng-container>
          </div>
          <div class="col-3 pl-2 vertical-spacer" style="overflow-y: auto; height: 12.5rem;">
            <p class="pl-4 text-primary font-size-small"><b>{{"LOGBOOK.TURBINE.FILTER.EVENT_CODE" |translate}}</b></p>
            <ng-container *ngTemplateOutlet="errorCodeFilter"></ng-container>
            <p class="mt-4 pl-4 text-primary font-size-small"><b>{{"LOGBOOK.TURBINE.FILTER.HIDE_LOGS" | translate}}</b></p>
            <ng-container *ngTemplateOutlet="hideErrorCodeFilter"></ng-container>
            @for (exception of exceptions; track exception; let i = $index) {
              <div>
                <p class="mt-4 pl-4 text-primary d-flex justify-content-between align-items-center">
                  <b>{{"LOGBOOK.TURBINE.FILTER.EXCEPTION" | translate}}</b>
                  <i role="img" [attr.aria-label]="'IMAGE_DESCRIPTION.DELETE' | translate" class="far fa-trash-alt text-primary font-size-normal cursor-pointer" (click)="deleteException(i)"></i>
                </p>
                <ng-template #exceptionHideErrorCodeFilter>
                  <div>
                    <li role="menuitem">
                      <div style="padding-left: 1.3rem">
                        <input class="error-code-input" [(ngModel)]="exceptions[i].value" (keyup.enter)="updateFilterValues()" (focusout)="updateFilterValues()" type="text" [placeholder]="('LOGBOOK.TURBINE.FILTER.ENTER_EVENT' |translate)">
                      </div>
                    </li>
                  </div>
                </ng-template>
                <ng-container *ngTemplateOutlet="exceptionHideErrorCodeFilter"></ng-container>
              </div>
            }
            <div class="pl-4">
              @if (IsHideLogsFilter) {
                <button class="btn btn-primary mt-3" (click)="addExceptions()">+ {{"LOGBOOK.TURBINE.FILTER.EXCEPTION" | translate}}</button>
              }
            </div>
          </div>
          <div class="col-7 pl-2">
            <p class="pl-4 text-primary font-size-small"><b>{{"LOGBOOK.TURBINE.FILTER.TCLASS" |translate}}</b></p>
            <ng-container *ngTemplateOutlet="tclassFilter"></ng-container>
          </div>
        </div>
      }
      @if (view === 'alarms') {
        <div class="row" >
          <div class="col-12 pl-2">
            @if (view === 'general') {
              <p class="text-center">{{"LOGBOOK.TURBINE.FILTER.TCLASS" |translate}}</p>
            }
            <ng-container *ngTemplateOutlet="tclassFilter"></ng-container>
          </div>
        </div>
      }
      @if (view === 'losses_review') {
        <div class="row">
          <div class="col-4 pl-2 vertical-spacer">
            <p class="pl-4 text-primary"><b>{{"LOGBOOK.TURBINE.FILTER.DURATION" |translate}}</b></p>
            <ng-container *ngTemplateOutlet="durationFilter"></ng-container>
          </div>
          <div class="col-8 pl-2">
            <p class="text-center">{{"LOGBOOK.TURBINE.FILTER.TCLASS" |translate}}</p>
            <ng-container *ngTemplateOutlet="tclassFilter"></ng-container>
          </div>
        </div>
      }
    </ul>
  }
</div>

<ng-template #durationFilter>
  @for (d of durationFilterOptions; track d; let i = $index) {
    <li role="menuitem">
      <div class="duration-radio dropdown-item" style="justify-content: flex-start; padding: 0.5rem 1rem">
        <input type="radio" id="r{{i + 1}}" [value]="d" [(ngModel)]="selectedDurationFilter" (ngModelChange)="updateFilterValues()" style="margin-right: 10px;">
        <label for="r{{i + 1}}" class="duration-radio-label">{{ d.description |translate}}</label>
      </div>
    </li>
  }
</ng-template>

<ng-template #errorCodeFilter>
  <div style="overflow-y: auto;">
    <li role="menuitem">
      <div class="" style="padding-left: 1.3rem">
        <input class="error-code-input" [(ngModel)]="selectedCodeFilter" (keyup.enter)="updateFilterValues()" (focusout)="updateFilterValues()" type="text" [placeholder]="('LOGBOOK.TURBINE.FILTER.ENTER_EVENT' |translate)">
      </div>
    </li>
  </div>
</ng-template>

<ng-template #hideErrorCodeFilter>
  <div style="overflow-y: auto;">
    <li role="menuitem">
      <div class="" style="padding-left: 1.3rem">
        <input class="error-code-input" [(ngModel)]="hideLogsFilter" (keyup)="onKeyup($event)" (keyup.enter)="updateFilterValues()" (focusout)="updateFilterValues()" type="text" [placeholder]="('LOGBOOK.TURBINE.FILTER.ENTER_EVENT' |translate)">
      </div>
    </li>
  </div>
</ng-template>

<ng-template #tclassFilter>
  <div style="overflow-y: auto; height: 10.5rem;">
    <li role="menuitem" (click)="toggleSelectAll()">
      <div class="dropdown-item select-all-item">
        <div class="check-element">
          <input type="checkbox" id="allTclass" [(ngModel)]="selectAllTClass" class="tclass-filter-checkbox custom-tclass-checkbox" style="margin-right: 20px; margin-left: 6px">
          <label for="allTclass" class="tclass-description"><b>{{"LOGBOOK.TURBINE.FILTER.ALL_TCLASS" |translate}}</b></label>
        </div>
      </div>
      <div class="dropdown-divider m-0"></div>
    </li>
    @for (class of tclassList; track class; let i = $index) {
      <li role="menuitem">
        <div class="dropdown-item custom-tclass-checkbox" [ngStyle]="{'border-left': '6px solid ' + blockService.getSpecificColor('tc', class.id)}">
          <div class="check-element" (click)="onDropdownSelected({index:i, class: class})">
            <input id="c{{i + 1}}" type="checkbox" [(ngModel)]="class.selected" (ngModelChange)="updateFilterValues(class)" class="tclass-filter-checkbox mr-2">
            <label for="c{{i + 1}}" (click)="onDropdownSelected({index:i, class: class})" class="tclass-description" [ngClass]="{'font-bold' : class.id === class.tcu}">{{ class?.description | titlecase }}</label>
          </div>
          <i (click)="onDropdownSingleSelected({index:i, class: class})" container="body" [matTooltip]="('LOGBOOK.TURBINE.FILTER.SELECT_ONLY' |translate)" style="font-size: 14px" class="far fa-bullseye"></i>
        </div>
        @if (tclassList.length - 1 !== i) {
          <div class="dropdown-divider m-0"></div>
        }
      </li>
    }
  </div>
</ng-template>
